import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/LiveDatas/Get`, payload),
    GetByID: (payload) => Repository.post(`/api/LiveDatas/GetByID`, payload),
    Add: (payload) => Repository.post(`/api/LiveDatas/Add`, payload),
    Edit: (payload) => Repository.post(`/api/LiveDatas/Edit`, payload),
    UpdatePlayback: (payload) => Repository.post(`/api/LiveDatas/UpdatePlayback`, payload),
}
